<template>
  <section-vue :no-bottom-padding="true" class="business-devices">
    <div class="container grid-css">
      <img
        class="business-devices__image"
        :src="$options.image[$i18n.locale]['1x']"
        :srcset="`${$options.image[$i18n.locale]['2x']} 2x`"
      />
    </div>
  </section-vue>
</template>

<script>
import SectionVue from "@/shared/section"
import deviceImageEn from "@/pages/business/images/devices/devices-en.png"
import deviceImageDe from "@/pages/business/images/devices/devices-de.png"
import deviceImageEn2x from "@/pages/business/images/devices/devices-en@2x.png"
import deviceImageDe2x from "@/pages/business/images/devices/devices-de@2x.png"

export default {
  name: "BusinessDevices",
  components: {
    SectionVue
  },
  image: {
    en: {
      "1x": deviceImageEn,
      "2x": deviceImageEn2x
    },
    de: {
      "1x": deviceImageDe,
      "2x": deviceImageDe2x
    }
  }
}
</script>

<style lang="scss">
.business-devices {
  position: relative;

  &:before {
    content: "";

    position: absolute;
    top: 0;
    bottom: 16%;

    display: block;
    width: 100%;

    background: $blue7;
  }

  &__image {
    @include grid-css-element(10, 2);

    position: relative;

    display: block;
  }
}
</style>
